export default __webpack_public_path__ + "static/media/icon5.6e39985c.svg";